'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var LadderDetailsButtonsController = function LadderDetailsButtonsController($scope, ladderApproverDetailsService, recommendationEntryDataService, recommendationEntryService, analysisDataService, dataTransformerService, saveAdjustedFaresService, alignFaresService, competitorPanelChartService, FaresOptimizerConstants, $timeout, faresOptimizerSharedFbcService, $rootScope, filingFilterService) {
  var endStatus = ['Rejected', 'Failed', 'Approved', 'Undo Initiated', 'Undo Failed', 'Undo Filed', 'Undo Validated', 'Validated With Errors'];
  var LADDER_COUNT = 1;
  $scope.$watch('currentRow', function (currentRow) {
    if (currentRow || currentRow.data) {
      updateToolTipsAndToastrMessages();
    }
  });
  $scope.$watchCollection('screenState.displayedRawData', function () {
    var data = $scope.screenState.displayedRawData;
    if (data && data.length) {
      updateRecommendationDetailsContextWithStatus($scope.screenState.displayedRawData, $scope.screenState.recommendationDetailsPanel.contextData);
      if (sevenKeyMatches($scope.currentRow.data, $scope.screenState.recommendationDetailsPanel.contextData)) {
        updateFareLaddersInGroupWithStatus($scope.screenState.displayedRawData, $scope.screenState.recommendationDetailsPanel.contextData);
      }
    }
  });
  function sevenKeyMatches(currentRow, contextData) {
    if (!_.isNil(currentRow) && !_.isNil(contextData)) {
      var currentRowKey = currentRow.fareRecommendationRecordKey + currentRow.createdAt;
      var contextDataKey = contextData.fareRecommendationRecordKey + contextData.createdAt;
      return currentRowKey === contextDataKey;
    }
    return false;
  }
  $scope.isStatusInEndStatus = function (status) {
    var findIndex = _.find(endStatus, function (o) {
      return o === status;
    });
    return !_.isUndefined(findIndex) && !$scope.isBenchmarkCompetitor && !recommendationEntryService.ladderWithApprovalDateInFuture($scope.currentRow.data);
  };
  $scope.hasSharedFbc = function () {
    return _.get($scope, 'currentRow.data.hasSharedFbc');
  };
  $scope.hasTargetFaresDiscontinued = function () {
    return _.get($scope, 'currentRow.data.hasTargetFaresDiscontinued');
  };
  $scope.allFaresCancelled = function () {
    return _.get($scope, 'currentRow.data.allFaresCancelled');
  };
  $scope.isCurrentRecommendationInProcess = function () {
    var matchingLadders = _.filter(_.map($scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList, 'data'), {
      'fareRecommendationRecordKey': $scope.currentRow.data.fareRecommendationRecordKey
    });
    var inProcessLadderExists = false;
    if (matchingLadders.length > 1) {
      _.forEach(matchingLadders, function (ladder) {
        if (!ladder.isExpired) {
          inProcessLadderExists = ladder.status === FaresOptimizerConstants.FILED || ladder.status === FaresOptimizerConstants.UNDO_INITIATED || ladder.status === FaresOptimizerConstants.UNDO_FILED;
        }
      });
    }
    return inProcessLadderExists;
  };
  $scope.undoNotAllowed = function () {
    return $scope.hasTargetFaresDiscontinued() || $scope.hasSharedFbc() || $scope.allFaresCancelled() || $scope.disableApproveRejectButtons() || $scope.isCurrentRecommendationInProcess() || $scope.getStatus() === 'Filed' && $scope.screenState.recommendMode === 'STRUCTURAL';
  };
  $scope.getData = function () {
    var data = _.get($scope, 'currentRow.data');
    if (data === undefined) {
      data = _.get($scope, 'currentRow');
    }
    return data;
  };
  $scope.getStatus = function () {
    var status = _.get($scope, 'currentRow.data.status');
    if (_.isNil(status)) {
      status = _.get($scope, 'currentRow.status');
    }
    if ($scope.isCompView && !$scope.isEffFareChart) {
      status = FaresOptimizerConstants.NEW;
    } else if ($scope.isBenchmarkView && $scope.isBenchmarkCompetitor) {
      status = FaresOptimizerConstants.APPROVED;
    }
    return status;
  };
  $scope.isApprovedLadderRejectable = function () {
    return recommendationEntryService.ladderWithApprovalDateInFuture($scope.currentRow.data);
  };
  $scope.getStatusInUpperCase = function () {
    return _.toUpper($scope.getStatus());
  };
  $scope.getStatusInLowerCase = function () {
    var status = $scope.getStatus().replace(/ /g, '');
    return _.toLower(status);
  };
  function getApproverLevel() {
    return ladderApproverDetailsService.getApproveType($scope.getData());
  }
  function isOnlyApprover() {
    return ladderApproverDetailsService.isUserOnlyApproverForCurrentPos($scope.getData());
  }
  function getLadderIds(data) {
    return _.map([data], 'fareRecommendationRecordKey');
  }
  function getApprovedLadderCount(data) {
    if ($scope.hasSharedFbc()) {
      return faresOptimizerSharedFbcService.getLadderDetailsForApproval([data], $scope.screenState.rawData, $scope.recalculatedLadder).length;
    }
    return LADDER_COUNT;
  }
  $scope.isButtonDivEnabled = function () {
    return $scope.getStatus() === FaresOptimizerConstants.NEW || $scope.getStatus() === FaresOptimizerConstants.PENDING || $scope.getStatus() === FaresOptimizerConstants.FILED || $scope.getStatus() === FaresOptimizerConstants.VALIDATED || recommendationEntryService.ladderWithApprovalDateInFuture($scope.currentRow.data);
  };
  function isHostViewPanel() {
    return $scope.screenState !== undefined && $scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.HOST_VIEW;
  }
  function isCompetitiveViewPanel() {
    return $scope.screenState !== undefined && $scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.COMPETITIVE_VIEW;
  }
  function isBenchmarkViewPanel() {
    return $scope.screenState !== undefined && $scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.BENCHMARK_VIEW;
  }
  function isEffectiveFareChart() {
    return $scope.currentRow !== undefined && $scope.currentRow.title.indexOf(FaresOptimizerConstants.EFFECTIVE_FARES_CHART_TITLE) > -1;
  }
  function shouldDisplayAlignActive() {
    return !$scope.isWebFareChart && $scope.isCompView && (!$scope.isEffFareChart || $scope.isEffFareChart && $scope.currentRow.data.showAdjustFares);
  }
  $scope.shouldDisplayApproveRejectButtons = function () {
    return $scope.isHostView || $scope.isCompView && $scope.isEffFareChart && !$scope.currentRow.data.showAdjustFares || $scope.isBenchmarkView && !$scope.isBenchmarkCompetitor;
  };
  $scope.initController = function () {
    $scope.groupedDataCollapsed = true;
    $scope.isExpanded = true;
    $scope.detailsDisabled = false;
    $scope.createApproveModal = false;
    $scope.createRejectModal = false;
    $scope.createUndoModal = false;
    initializeDisplayMessages();
    $scope.isHostView = isHostViewPanel();
    $scope.isCompView = isCompetitiveViewPanel();
    $scope.isBenchmarkView = isBenchmarkViewPanel();
    $scope.isEffFareChart = isEffectiveFareChart();
    $scope.isSelectedLowestTotal = true;
    $scope.isSelectedLowestNet = false;
    $scope.isWebFareChart = isWebFareChart();
    $scope.showAlignOrActive = shouldDisplayAlignActive();
    drawWebFareChart();
  };
  $scope.toggleExpanded = function () {
    $scope.isExpanded = !$scope.isExpanded;
  };
  $scope.isFootnoteDatesValid = function () {
    return recommendationEntryService.isFootnoteDatesValid($scope.getData());
  };
  $scope.areThereProductsForFiling = function () {
    return filingFilterService.areThereProductsForFiling($scope.getData());
  };
  $scope.disableApproveRejectButtons = function () {
    return getApproverLevel() === undefined;
  };
  $scope.isApprovableForCurrentUser = function () {
    return ladderApproverDetailsService.isApprovable($scope.getData(), getApproverLevel(), isOnlyApprover());
  };
  $scope.showNoRecomMessage = function () {
    if ($scope.isBenchmarkView) {
      return !$scope.isBenchmarkCompetitor && $scope.getStatus() === FaresOptimizerConstants.NO_RECOM;
    } else {
      return $scope.getStatus() === FaresOptimizerConstants.NO_RECOM;
    }
  };
  $scope.showBenchmarkViewCompetitorMessage = function () {
    return $scope.isBenchmarkView && $scope.isBenchmarkCompetitor && !isWebFareChart();
  };
  function initializeDisplayMessages() {
    $scope.approveButton = 'Approve';
    $scope.rejectButton = 'Reject';
    $scope.undoButton = 'Undo';
    $scope.criticalUndoButton = 'Critical Undo';
    $scope.approveTooltip = 'Only New and Pending Recommendations can be Approved';
    $scope.rejectTooltip = 'Only New and Pending Recommendations can be Rejected';
    $scope.undoTooltip = '';
    $scope.criticalUndoTooltip = '';
    $scope.approveToastrError = 'Only New and Pending Recommendations can be Approved';
    $scope.rejectToastrError = 'Only New and Pending Recommendations can be Rejected';
  }
  function updateToolTipsAndToastrMessages() {
    if (getApproverLevel() === 'intermediate') {
      $scope.approveTooltip = 'Only New Recommendations can be Approved';
      $scope.rejectTooltip = 'Only New Recommendations can be Rejected';
      $scope.approveToastrError = 'Only New Recommendations can be Approved';
      $scope.rejectToastrError = 'Only New Recommendations can be Rejected';
    } else if (!isOnlyApprover() && getApproverLevel() === 'final') {
      $scope.approveTooltip = 'Only Pending Recommendations can be Approved';
      $scope.rejectTooltip = 'Only Pending Recommendations can be Rejected';
      $scope.approveToastrError = 'Only Pending Recommendations can be Approved';
      $scope.rejectToastrError = 'Only Pending Recommendations can be Rejected';
    } else if (getApproverLevel() === undefined) {
      $scope.approveTooltip = '';
      $scope.rejectTooltip = '';
    }
  }
  $scope.approveAll = function () {
    var ladderDetailsForApproval = faresOptimizerSharedFbcService.getLadderDetailsForApproval([$scope.getData()], $scope.screenState.rawData, $scope.recalculatedLadder);
    if (!$scope.disableApproveRejectButtons() && $scope.isApprovableForCurrentUser()) {
      $scope.approveModalData = {
        count: LADDER_COUNT,
        effectiveDate: $scope.getData().recommendationEffectiveDate,
        authorizationNotes: $scope.getData().authorizationNotes,
        hasSharedFbc: faresOptimizerSharedFbcService.getSharedEntryLevelFbcs([$scope.getData()], $scope.screenState.rawData).length >= 1,
        ladderDetails: ladderDetailsForApproval,
        affectedLadderIdCount: getApprovedLadderCount($scope.getData()),
        maxAllowedApprovalDate: recommendationEntryService.getMinimumOfTravelAndReservationDates($scope.getData())
      };
      $scope.showApproveModal = true;
      $scope.createApproveModal = true;
    }
  };
  $scope.undo = function () {
    $scope.stateChangeModal = {
      count: LADDER_COUNT,
      fareRecommendationUndoKeyList: _.chain([$scope.getData()]).map(function (entry) {
        return {
          fareRecommendationRecordKey: entry.fareRecommendationRecordKey,
          createdAt: entry.createdAt,
          status: entry.status
        };
      }).value()
    };
    $scope.showUndoModal = true;
    $scope.createUndoModal = true;
  };
  $scope.rejectAll = function () {
    var ladderDetailsForRejection = getLadderDetailsForRejection($scope.getData(), $scope.screenState.rawData);
    if (!$scope.disableApproveRejectButtons() && $scope.isApprovableForCurrentUser()) {
      $scope.rejectModalData = {
        count: LADDER_COUNT,
        ladderIds: getLadderIds($scope.getData()),
        entryLevelFbcs: _.chain(ladderDetailsForRejection).map('fbc').value()
      };
      $scope.showRejectModal = true;
      $scope.createRejectModal = true;
    }
  };
  function getLadderDetailsForRejection(data, rawData) {
    var ladderIds = getLadderIds(data);
    return _.chain(ladderIds).map(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      return {
        ladderId: ladderId,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*')
      };
    }).value();
  }
  function rejectLadder() {
    $scope.screenState.reorderGroupOptions = false;
    $timeout(recommendationEntryDataService.updateRecommendationStatus('reject', {
      authorizationNotes: $scope.rejectModalData.authorizationNotes,
      fareRecommendationRecordKeyList: $scope.rejectModalData.ladderIds || [],
      rejectionExpiryDateTime: $scope.rejectModalData.rejectionExpiryDateTime && $scope.rejectModalData.rejectionExpiryDateTime.format('YYYY-MM-DDTHH:mm:ss.000ZZ')
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, $scope.screenState.recommendationDetailsPanel.selectedHostLadder, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage), 1);
    $scope.recalculatedLadder = undefined;
  }
  function approveLadder() {
    $scope.screenState.reorderGroupOptions = false;
    $timeout(recommendationEntryDataService.updateRecommendationStatus('approve', {
      authorizationNotes: $scope.approveModalData.authorizationNotes,
      fareRecommendationRecordKeyList: _.chain($scope.approveModalData.ladderDetails).map('ladderId').value() || [],
      effectiveTimeStamp: $scope.approveModalData.effectiveDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ')
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, $scope.screenState.recommendationDetailsPanel.selectedHostLadder, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage), 1);
  }
  function upsertAndApproveService() {
    if ($scope.recalculatedLadder !== undefined) {
      $scope.screenState.recommendationDetailsPanel.selectedHostLadder.data = $scope.currentRow.data;
      var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.contextData.fareLaddersInGroup;
      var selectedFareLadder = _.find(fareLaddersInGroup, {
        fareRecommendationRecordKey: $scope.currentRow.data.fareRecommendationRecordKey
      });
      var index = _.indexOf(fareLaddersInGroup, selectedFareLadder);
      fareLaddersInGroup.splice(index, 1, $scope.currentRow.data);
      recommendationEntryDataService.upsertLadder($scope.recalculatedLadder).then(function () {
        approveLadder();
        $scope.recalculatedLadder = undefined;
      });
    } else {
      approveLadder();
    }
  }
  function setTotalFareThreshold(clonedHostLadders) {
    _.forEach(clonedHostLadders, function (hostLadderEntry) {
      hostLadderEntry.minFareThreshold = alignFaresService.getTotalFareThreshold(hostLadderEntry.minFareThreshold, hostLadderEntry, hostLadderEntry.benchmarkFareComponent);
      hostLadderEntry.maxFareThreshold = alignFaresService.getTotalFareThreshold(hostLadderEntry.maxFareThreshold, hostLadderEntry, hostLadderEntry.benchmarkFareComponent);
    });
  }
  function validateFaresAndApproveOrRejectLadder(isApprove) {
    var clonedHostLadders = _.cloneDeep($scope.currentRow.hostLadder);
    var filteredClonedLadders = _.filter(clonedHostLadders, function (effFare) {
      return _.isNil(effFare.sponsorMarketFbc) && _.isNil(effFare.dualRbdSponsorFbc);
    });
    _.each(filteredClonedLadders, function (clonedHostFare) {
      clonedHostFare.minFareThreshold = Math.round(clonedHostFare.minFareThreshold);
      clonedHostFare.maxFareThreshold = Math.round(clonedHostFare.maxFareThreshold);
    });
    setTotalFareThreshold(filteredClonedLadders);
    var isFareWithinThreshold = saveAdjustedFaresService.modifiedFareWithinFareThresholdCheck(filteredClonedLadders);
    if (!isFareWithinThreshold) {
      toastr.error('User fare adjustments not within Min/Max thresholds. Please correct and save again');
    } else {
      var alignLadderPayload = saveAdjustedFaresService.getAlignLadderPayload($scope.currentRow.recomId, $scope.currentRow.hostLadder);
      $scope.screenState.reorderGroupOptions = false;
      analysisDataService.alignFareRecommendations(alignLadderPayload, $scope.screenState.displayedRawData, $scope.screenState.rawData).then(function (data) {
        var result = dataTransformerService.transformRecommendationLadder(data)[0];
        var fareLaddersInGroup = $scope.screenState.recommendationDetailsPanel.contextData.fareLaddersInGroup;
        saveAdjustedFaresService.updateGroupedRowsFares(result, $scope.currentRow, $scope.screenState.recommendationDetailsPanel.selectedHostLadder, $scope.currentRow.hostLadder, fareLaddersInGroup);
        if (isApprove) {
          approveLadder();
        } else {
          rejectLadder();
        }
      });
    }
  }
  $scope.approveCallback = function () {
    if ($scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.COMPETITIVE_VIEW) {
      validateFaresAndApproveOrRejectLadder(true);
    } else if ($scope.screenState.recommendationDetailsMode === 'benchmarkView') {
      upsertAndApproveService();
    } else {
      approveLadder();
    }
  };
  $scope.undoCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    recommendationEntryDataService.updateRecommendationStatus('undo', {
      authorizationNotes: $scope.stateChangeModal.authorizationNotes,
      fareRecommendationUndoKeyList: $scope.stateChangeModal.fareRecommendationUndoKeyList
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData);
  };
  $scope.rejectCallback = function () {
    if ($scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.COMPETITIVE_VIEW) {
      validateFaresAndApproveOrRejectLadder(false);
    } else {
      rejectLadder();
    }
  };
  $scope.stateChangeCallBack = function (state) {
    $scope.screenState.reorderGroupOptions = false;
    recommendationEntryDataService.updateRecommendationStatus(state, $scope.stateChangeModal, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage);
  };
  function updateRecommendationDetailsContextWithStatus(rawData, incomingContextData) {
    var fareLaddersInGroup = incomingContextData.fareLaddersInGroup;
    _.forEach(fareLaddersInGroup, function (ladder) {
      updateFareLaddersInGroupWithStatus(rawData, ladder);
    });
    return incomingContextData;
  }
  function updateFareLaddersInGroupWithStatus(rawData, ladder) {
    var recommendationRecordKey = ladder.fareRecommendationRecordKey;
    var createdAt = ladder.createdAt;
    var match = _.find(rawData, {
      fareRecommendationRecordKey: recommendationRecordKey,
      createdAt: createdAt
    });
    if (match) {
      ladder.status = match.status;
      ladder.displayStatus = match.displayStatus;
      ladder.recommendationEffectiveDate = match.recommendationEffectiveDate;
    }
  }
  function isEffectiveFare(title) {
    var pattern = new RegExp(' ' + FaresOptimizerConstants.EFFECTIVE_FARES_CHART_TITLE + '$', 'g');
    return pattern.test(title);
  }
  function updateEffectiveFaresAfterAlign(ladder, effFareLadder, groupedRows) {
    alignFaresService.setAdjustEffectiveFareData($scope.entryLevelEffectiveFare, ladder);
    $scope.entryLevelEffectiveFare.hostLadder = effFareLadder;
    alignFaresService.updateEffectiveFaresInGroupedRows(effFareLadder, groupedRows);
    $scope.chartSettings.fareRange = competitorPanelChartService.getFareChartScaleSettings(ladder, effFareLadder).fareRange;
    $scope.entryLevelEffectiveFare.data.userAdjustedDates = effFareLadder.userAdjustedDates;
    var effectiveFaresIndex = _.findIndex($scope.chartDataList, function (dataList) {
      return isEffectiveFare(dataList.title);
    });
    $scope.chartDataList[effectiveFaresIndex] = $scope.entryLevelEffectiveFare;
  }
  function updateCurrentFaresAfterAlign(ladder, effFareLadder, groupedRows) {
    alignFaresService.setAdjustEffectiveFareData($scope.currentFareChartData, ladder);
    $scope.currentFareChartData.hostLadder = effFareLadder;
    alignFaresService.updateCurrentFaresInGroupedRows(effFareLadder, groupedRows);
    $scope.chartSettings.fareRange = competitorPanelChartService.getFareChartScaleSettings(ladder, effFareLadder).fareRange;
    $scope.currentFareChartData.data.userAdjustedDates = effFareLadder.userAdjustedDates;
    $scope.chartDataList[1] = $scope.currentFareChartData;
  }
  function updateRecommendedFaresAfterAlign(ladder, effFareLadder, groupedRows) {
    alignFaresService.setAdjustEffectiveFareData($scope.recommendedFareChartData, ladder);
    $scope.recommendedFareChartData.hostLadder = effFareLadder;
    alignFaresService.updateRecommendedFaresInGroupedRows(effFareLadder, groupedRows);
    $scope.chartSettings.fareRange = competitorPanelChartService.getFareChartScaleSettings(ladder, effFareLadder).fareRange;
    $scope.recommendedFareChartData.data.userAdjustedDates = effFareLadder.userAdjustedDates;
    $scope.chartDataList[0] = $scope.recommendedFareChartData;
  }
  $scope.alignFares = function (chartData) {
    _.forEach(_.range(0, $scope.chartDataList.length - 1), function (index) {
      $scope.chartDataList[index].isActive = false;
    });
    var effFareLadder = $scope.entryLevelEffectiveFare.hostLadder;
    var selectedRecomLadderFromRawData = $scope.screenState.recommendationDetailsPanel.selectedHostLadder.data;
    var dataForCheck = {
      hostCarrier: selectedRecomLadderFromRawData.carrier,
      compCarrier: chartData.data.carrier,
      hostFareType: selectedRecomLadderFromRawData.tripType,
      compFareType: chartData.data.tripType
    };
    if (isAlignNotAllowed(dataForCheck)) {
      return toastr.error('Align not allowed for ' + dataForCheck.hostFareType + ' host and ' + dataForCheck.compFareType + ' competitor fare type indicators');
    }
    return alignFaresService.alignEffectiveFares(chartData, effFareLadder, selectedRecomLadderFromRawData, $scope.entryLevelEffectiveFare.data.groupedRows).then(_.partialRight(updateAlignedEffectiveServices, selectedRecomLadderFromRawData, chartData))["catch"](function (error) {
      toastr.error(error);
    });
  };
  function updateAlignedEffectiveServices(newEffFareLadder, selectedRecomLadderFromRawData, chartData) {
    updateEffectiveFaresAfterAlign(selectedRecomLadderFromRawData, newEffFareLadder, $scope.entryLevelEffectiveFare.data.groupedRows);
    updateRecommendedFaresAfterAlign(selectedRecomLadderFromRawData, newEffFareLadder, $scope.recommendedFareChartData.data.groupedRows);
    updateCurrentFaresAfterAlign(selectedRecomLadderFromRawData, newEffFareLadder, $scope.currentFareChartData.data.groupedRows);
    chartData.isActive = true;
    $rootScope.$broadcast('aligned:fares', $scope.entryLevelEffectiveFare, $scope.entryLevelEffectiveFare._userAdjustedDates);
  }
  function isAlignNotAllowed(dataForCheck) {
    if (dataForCheck.hostCarrier === dataForCheck.compCarrier) {
      return false;
    }
    return !areSameTripTypesOrSingleDirection(dataForCheck.hostFareType, dataForCheck.compFareType);
  }
  function areSameTripTypesOrSingleDirection(hostTrip, compTrip) {
    return hostTrip === compTrip || hostTrip === 'OW' && compTrip === 'OWNC' || hostTrip === 'OWNC' && compTrip === 'OW';
  }
  $scope.alignDisabled = function (currentRow) {
    return alignFaresService.checkAlignButtonStatus(currentRow);
  };
  function isWebFareChart() {
    return $scope.currentRow !== undefined && $scope.currentRow.title.indexOf(FaresOptimizerConstants.WEB_FARE_CHART_TITLE) > -1;
  }

  /* Web Fare chart repaint -- STARTS */
  function drawWebFareChart() {
    if (isWebFareChart()) {
      $scope.selectedLowestWebFare = {};
      $scope.webFareToggleItems = [{
        label: FaresOptimizerConstants.WEB_FARE_TOGGLE_LABELS.TOTAL,
        value: FaresOptimizerConstants.WEB_FARE_LOWEST_TOTAL_KEY,
        disabled: false
      }, {
        label: FaresOptimizerConstants.WEB_FARE_TOGGLE_LABELS.BASE,
        value: FaresOptimizerConstants.WEB_FARE_LOWEST_BASE_KEY,
        disabled: false
      }];
      $scope.toggleWebFare = function (type) {
        $scope.selectedLowestWebFare.type = type;
      };
      $scope.displayLowestWebFare = function (type, webFareData) {
        $scope.toggleWebFare(type);
        $scope.$emit('chart.webfare.toggle.faretype', {
          'webFareData': webFareData,
          'type': type
        });
      };
      // SET the default display to lowest total fare
      $scope.toggleWebFare(FaresOptimizerConstants.WEB_FARE_LOWEST_TOTAL_KEY);
    }
  }

  /* Web Fare chart repaint -- ENDS */

  $scope.initController();
};
LadderDetailsButtonsController.$inject = ['$scope', 'LadderApproverDetailsService', 'RecommendationEntryDataService', 'RecommendationEntryService', 'FaresOptimizerAnalysisDataService', 'FaresOptimizerDataTransformerService', 'FaresOptimizerSaveAdjustedFaresService', 'FaresOptimizerAlignFaresService', 'CompetitorPanelChartService', 'FaresOptimizerConstants', '$timeout', 'FaresOptimizerSharedFbcService', '$rootScope', 'FaresOptimizerFilingLadderFilterService'];
module.exports = LadderDetailsButtonsController;